var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhyfintoo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.30151 1.53552C8.30151 0.705835 8.97183 0.0355225 9.80151 0.0355225H11.3015C12.1312 0.0355225 12.8015 0.705835 12.8015 1.53552C13.6312 1.53552 14.3015 2.20583 14.3015 3.03552V13.5355C14.3015 14.3652 13.6312 15.0355 12.8015 15.0355C12.8015 15.8652 12.1312 16.5355 11.3015 16.5355H9.80151C8.97183 16.5355 8.30151 15.8652 8.30151 15.0355C7.47183 15.0355 6.80151 14.3652 6.80151 13.5355V3.03552C6.80151 2.20583 7.47183 1.53552 8.30151 1.53552ZM2.30151 21.0355H15.8015C19.1156 21.0355 21.8015 18.3496 21.8015 15.0355C21.8015 11.7215 19.1156 9.03552 15.8015 9.03552V6.03552C20.7703 6.03552 24.8015 10.0668 24.8015 15.0355C24.8015 17.3418 23.9343 19.4418 22.5093 21.0355H23.3015C24.1312 21.0355 24.8015 21.7058 24.8015 22.5355C24.8015 23.3652 24.1312 24.0355 23.3015 24.0355H15.8015H2.30151C1.47183 24.0355 0.801514 23.3652 0.801514 22.5355C0.801514 21.7058 1.47183 21.0355 2.30151 21.0355ZM6.05151 18.0355H15.0515C15.464 18.0355 15.8015 18.373 15.8015 18.7855C15.8015 19.198 15.464 19.5355 15.0515 19.5355H6.05151C5.63901 19.5355 5.30151 19.198 5.30151 18.7855C5.30151 18.373 5.63901 18.0355 6.05151 18.0355Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyfintoo2);
export default __webpack_public_path__ + "static/media/whyfintoo2.b65ef7b35139d407b93e2dd24586f43c.svg";
export { ForwardRef as ReactComponent };